export const continueShoppingRedirects = {
  '/store/form-3-basic-package-without-service/':
    '/store/form-3-basic-package-without-service/'
};
